export default {
    SET_FORM_JSON(state,payload) {
        state.formJSON =payload;
    }
};
